<template>
  <div class="main-layout">
    <AppNavbar />
    <v-layout class="layout-container">
      <AppSidebarV2 v-if="isAuthenticated" />
      <v-main
        :class="[
          'main-content',
          {
            'main-content-no-sidebar': !isAuthenticated,
            'main-content-sidebar-collapsed': isAuthenticated && isCollapsed,
          },
        ]"
      >
        <div class="main-content-wrapper">
          <router-view />
        </div>
      </v-main>
    </v-layout>
    <AppFooter />
  </div>
</template>

<script setup lang="ts">
  import AppFooter from '@components/layout/AppFooter.vue';
  import AppNavbar from '@components/layout/AppNavbar.vue';
  import AppSidebarV2 from '@components/layout/AppSidebarV2.vue';
  import { useAuth } from '@composables/useAuth';
  import { useSidebarState } from '@composables/useSidebarState';

  const { isAuthenticated } = useAuth();
  const { isCollapsed } = useSidebarState();
</script>

<style scoped lang="scss">
$navbar-height: 70px;
$sidebar-width: 256px;
$sidebar-rail-width: 72px;
$footer-height: 56px;

.main-layout {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.layout-container {
  position: relative;
  display: flex;
  flex-direction: row;
  margin-top: $navbar-height;
  max-height: calc(100vh - $navbar-height - $footer-height);
  width: 100%;
}

:deep(.v-main) {
  padding: 0;
  margin: 0;
  flex: 1;
  overflow-x: hidden;
}

.main-content {
  display: flex;
  flex-direction: column;
  flex: 1;
  // max-height: calc(100vh - $navbar-height - $footer-height);
  overflow-x: hidden;
  max-width: calc(100% - $sidebar-width);
  margin-left: $sidebar-width;
}

.main-content-no-sidebar {
  max-width: 100%;
  margin-left: 0;
}

.main-content-sidebar-collapsed {
  max-width: calc(100% - $sidebar-rail-width);
  margin-left: $sidebar-rail-width;
}

.main-content-wrapper {
  padding: 1.5rem;
  width: 100%;
  flex: 1;
  overflow-x: auto;
  box-sizing: border-box;
}
</style>
